module.exports = __webpack_public_path__ + "img/collection-weddingRingsTwoColors@2x.ea71807.jpg";